<template>
    <ul style="width: 100%">
        <li
            v-for="(item, index) in noteData"
            :class="item.level == 2 && index != noteData.length -1 ? 'li-line' : ''"
            :key="keyName + '_' + index">
          <template>
            <div class="d-flex">
              <div class="col-4 content-tree-note"
                   :class="((item.children.length && item.level != 2) || (item.level != 2)) && index != noteData.length -1 ? 'li-line-' + item.level : ''"
                   style="position: relative"
                   :style="'padding-left:' + parseInt(item.level*24) + 'px'">
                <div class="tree-header-name">
                  <div
                      v-if="!item.showEdit"
                      @click="item.isShow = !item.isShow;">
                    <v-icon style="transform: rotate(90deg); background: white">mdi-source-branch</v-icon>
                    {{ item.name }}
                  </div>
                  <input
                      v-else
                      style="height: 35px; padding: 5px; width: 100%; border: 2px solid #C4C4C4; background: white"
                      maxlength="255"
                      placeholder="Nhập tên..."
                      :id="'input_branch_name_' + item.id"
                      class="tree-header-name"
                      v-model="item.name"
                      @blur="updateBranch(item)"
                      @keyup.enter="item.showEdit = !item.showEdit"
                      @click="item.isShow = !item.isShow;"/>
                  <div class="btn-action-branch">
                    <span
                        v-if="checkAuthorization('setting-organization_update')"
                        @click="editBranch(item)">Sửa</span>
                    <span
                        v-if="checkAuthorization('setting-organization_update')
                          && checkAuthorization('setting-organization_delete')"
                    > | </span>
                    <span
                        v-if="checkAuthorization('setting-organization_delete')"
                        @click="deleteBranch(item)">Xóa</span>
                  </div>
                </div>
                <div>
                  <v-icon
                      @click="item.isShow = !item.isShow;"
                      class="icon-header-tree-note"
                      v-if="item.isShow">mdi-chevron-down</v-icon>
                  <v-icon
                      @click="item.isShow = !item.isShow;"
                      class="icon-header-tree-note"
                      v-else>mdi-chevron-right</v-icon>
                </div>
              </div>
              <div class="col-3 border-table">
  <!--              <v-col>-->
                  <template>
                      <span
                          class="item-kpi-content mr-1"
                          v-for="kpi in item.indicators">
                        {{ kpi.name }}
                      </span>
                    <div v-if="checkAuthorization('setting-organization_update')">
                      <v-menu
                          bottom
                          offset-y
                          absolute
                          v-model="item.openMenu"
                          content-class="wrapper-v-menu style-1"
                          :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on }">
                          <div v-show="item.indicators && item.indicators.length">
                            <v-icon size="14">mdi-pencil</v-icon>
                            <span
                                @click="openFormSelectKpi(item)"
                                class="btn-edit-kpi mt-3"
                                dark v-on="on"
                                height="30px" >
                                Chỉnh sửa
                              </span>
                          </div>
                          <div
                              v-show="!item.indicators || !item.indicators.length"
                              :class="item.openMenu ? 'btn-add-item selected' : 'btn-add-item'">
                            <v-icon
                                @click="openFormSelectKpi(item)"
                                v-on="on"
                                style="transform: translate(-1.5px, -1px)"
                                :color="item.openMenu ? 'white' : 'black'">
                              mdi-plus</v-icon>
                          </div>
                        </template>

                        <!--Form select kpi-->
                        <template>
                          <v-list
                              class=""
                              width="285px"
                              style="max-height: 400px;"
                              outlined
                          >
                            <v-list-item
                                style="min-height: unset"
                                three-line>
                              <v-list-item-content class="overflow-visible pb-0">
                                <v-row style="width: 100%; padding: 0px 20px">
                                  <v-text-field
                                      v-model="filterForm.kpiName"
                                      outlined
                                      hide-details
                                      placeholder="Tìm kiếm ..."
                                      dense
                                      clearable
                                      @keyup.enter.native="(searchKpi)"
                                  />
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>

                            <template v-if="item.kpiList && item.kpiList.length">
                              <div class="item-kpi-wrapper my-2 mt-4">
                                <span
                                    class="item-kpi-content mr-2 mt-2"
                                    v-for="kpi in item.kpiList">
                                  {{ kpi }}
                                  <v-icon color="#7367F0">mdi-check</v-icon>
                                </span>
                              </div>
                            </template>

                            <div style="max-height: 268px; overflow-y: auto;" class="style-1">
                              <div
                                  v-for="ite in kpiListAllCopy"
                                  class="item-kpi-wrapper my-2">
                                <h3
                                    style="word-break: break-word"
                                    class="py-2 border-bottom">
                                  {{ ite.name }}
                                </h3>
                                <div>
                                <span
                                    v-for="kpiItem in ite.indicators"
                                    :class="kpiItem.selected ? 'item-kpi-content mr-2 mt-2' : 'item-kpi-content-unselect mr-2 mt-2'"
                                    @click="handleSelectKpi(kpiItem)">
                                  {{ kpiItem.name }}
                                  <v-icon
                                      v-if="listKpiSelected.includes(kpiItem.id)"
                                      color="#7367F0">mdi-check</v-icon>
                                </span>
                                </div>
                              </div>
                            </div>

                            <div class="text-center py-4 item-kpi-wrapper">
                              <div
                                  @click="saveKpiForBranch(item)"
                                  class="mx-0 btn-confirm py-2">Xác nhận</div>
                            </div>
                          </v-list>
                        </template>
                      </v-menu>
                    </div>
                  </template>

              </div>


              <div class="col-3 border-table">


                <div v-for="rank in item.ranks" class="">
                  <div v-if="!rank.showEdit"
                       class="rank-data-content">
                    {{ rank.name }}
                    <span class="rank-item-actions">
                      <span style="cursor: pointer"
                            v-if="checkAuthorization('setting-organization_update')"
                            @click="editRank(rank)">Sửa</span>
                      <span
                          v-if="checkAuthorization('setting-organization_update')
                            && checkAuthorization('setting-organization_delete')"
                      > | </span>
                      <span style="cursor: pointer"
                            v-if="checkAuthorization('setting-organization_delete')"
                            @click="deleteRank(item, rank)">Xóa</span>
                    </span>
                  </div>
                  <input
                      v-else
                      style="height: 35px; padding: 5px; width: 100%; border: 2px solid #C4C4C4"
                      maxlength="255"
                      placeholder="Nhập tên lộ trình..."
                      :id="'input_rank_name_' + rank.id"
                      class="rank-header-name"
                      v-model="rank.name"
                      @blur="updateRank(rank)"
                      @keyup.enter="rank.showEdit = !rank.showEdit"/>
                  <div class="content-user-in-rank my-2 d-flex align-center">
                    <span v-for="(user, indexU) in rank.users">
                      <span v-if="indexU < 3">
                        <img
                            v-if="user.avatar"
                            class="item-avatar-user mr-1"
                            :src="user.avatar"/>
                        <img v-else
                             class="item-avatar-user mr-1"
                             src="../../../assets/default-avatar.jpg"/>
                      </span>
                    </span>
                    <span
                        class="more-item-user d-flex align-center mr-1 justify-center"
                        v-if="rank.users.length > 3">
                        +{{rank.users.length - 3}}
                    </span>

                      <!--Form add user for rank-->
                      <v-menu
                          bottom
                          offset-y
                          absolute
                          v-model="rank.openMenu"
                          content-class="wrapper-v-menu style-1"
                          :close-on-content-click="false">

                      <template v-slot:activator="{ on }">
                        <span
                            v-if="checkAuthorization('setting-organization_create')
                                  || checkAuthorization('setting-organization_update')
                                  || checkAuthorization('setting-organization_delete')"
                            :class="rank.openMenu ? 'btn-add-item selected' : 'btn-add-item'">
                          <v-icon
                              @click="openFormSelectUser(rank)"
                              v-on="on"
                              style="transform: translate(-1.5px, -1px)"
                              :color="rank.openMenu ? 'white' : 'black'">
                            mdi-plus</v-icon>
                        </span>
                      </template>

  <!--                      <template>-->
                          <v-list
                              class=""
                              width="285px"
                              style="max-height: 415px;"
                              outlined
                          >
                            <v-list-item
                                style="min-height: unset"
                                three-line>
                              <v-list-item-content class="overflow-visible pb-0">
                                <v-row style="width: 100%; padding: 0px 20px">
                                  <v-text-field
                                      v-model="filterForm.name"
                                      outlined
                                      hide-details
                                      placeholder="Tìm kiếm ..."
                                      dense
                                      @input="searchUser()"
                                  />
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>

                            <div v-if="rank.users && rank.users.length"
                                 class="item-user-list-wrapper my-2">
                              <h3>Nhân viên thuộc lộ trình làm việc</h3>
                              <div
                                  class="item-user-content mr-2 d-flex justify-space-between align-center"
                                  v-for="user in rank.users">
                                <div v-if="user.firstName && user.firstName"
                                     class="pt-1">{{ user.lastName + ' ' + user.firstName }}</div>
                                <div v-else
                                     class="pt-1">{{ user.fullName }}</div>
                                <input
                                    style="width: 18px; height: 18px"
                                    type="checkbox"
                                    class="mt-0"
                                    :ripple="false"
                                    v-model="listUserSelected"
                                    :value="user.id"
                                />

                              </div>
                            </div>

                            <h3 class="item-user-list-wrapper mt-4">Nhân viên</h3>
                            <div
                                v-if="checkAuthorization('setting-organization_create')"
                                class="item-user-list-wrapper my-2 style-1 wrapper-list-item">
                              <div
                                  class="item-user-content mr-2 d-flex justify-space-between align-center"
                                  v-for="user in userListCopy">
                                <div class="pt-1">{{ user.fullName }}</div>
                                <input
                                    style="width: 18px; height: 18px"
                                    type="checkbox"
                                    class="mt-0"
                                    v-model="listUserSelected"
                                    :value="user.id"
                                    :label="user.name"
                                />

                              </div>
                            </div>

                            <div class="text-center py-4 item-user-list-wrapper">
                              <div
                                  @click="saveUserForRank(rank)"
                                  class="mx-0 btn-confirm py-2">Xác nhận</div>
                            </div>
                          </v-list>
  <!--                      </template>-->
                    </v-menu>




                  </div>
                </div>


              </div>

              <div class="col-2 tree-action-btn border-tablecol-4 content-tree-note border-table">
                <div class="action row" style="font-size: 12px;">
                  <div class="btn-action-item"
                       v-if="checkAuthorization('setting-organization_create')"
                       color="primary"
                       @click="addBranch(item, index)">
                    <div><v-icon style="transform: rotate(90deg);">mdi-source-branch</v-icon></div>
                    <span>Thêm mới cấp dưới</span>
                  </div>

                  <div class="btn-action-item"
                       v-if="checkAuthorization('setting-organization_create')"
                       color="primary"
                       @click="addRank(item)">
                    <div><v-icon>mdi-lightning-bolt-outline</v-icon></div>
                    <span>Thêm <br/> lộ trình làm việc</span>
                  </div>

                  <div class="btn-action-item">
                    <v-menu
                        bottom
                        offset-y
                        absolute
                        v-model="item.openMenuPermission"
                        content-class="wrapper-v-menu style-1"
                        :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <div
                            @click="openMenuSelectPermission(item)"
                            v-on="on"
                            style="height: 100%">
                          <div>
                            <v-icon>mdi-view-grid-plus-outline</v-icon>
                          </div>
                          <span>Nhóm quyền</span>
                        </div>
                      </template>

                      <!--Form select permission-->
                      <template>
                        <v-list
                            class=""
                            width="285px"
                            style="max-height: 400px;"
                            outlined>
                          <div style="max-height: 320px; overflow-y: auto;" class="style-1">
                            <div
                                v-for="groupPermission in groupPermissionList"
                                class="item-kpi-wrapper my-2">
                              <h3
                                  style="word-break: break-word;"
                                  class="py-2 border-bottom">
                                {{ groupPermission.name }}
                              </h3>
                              <div>
                                <div
                                    v-for="permission in groupPermission.roles"
                                    :class="permission.selected ? 'item-role-content mr-2 mt-2' : 'item-role-content-unselect mr-2 mt-2'"
                                    @click="handleSelectRoles(permission)">
                                  {{ permission.name }}
                                  <v-icon
                                      v-if="listPermissionSelected.includes(permission.id)"
                                      color="#7367F0">mdi-check</v-icon>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="text-center py-4 item-kpi-wrapper">
                            <div
                                @click="saveRolesForBranch(item)"
                                class="mx-0 btn-confirm py-2">Xác nhận</div>
                          </div>
                        </v-list>
                      </template>
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>

            <tree-note-in-branch
                v-show="item.isShow"
                :userList="userList"
                :noteData="item.children"
                :kpiListAll="kpiListAll"
                :newTempOrgName="tempOrgName"
                :groupPermissionList="groupPermissionList"
                :keyName="index"/>

          </template>
        </li>
    </ul>
</template>

<script>
import moment from "moment";
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const organizationMachineRepository = RepositoryFactory.get('organization_machine');
export default {
  name: 'tree-note-in-branch',
  components: {},
  props: {
    noteData: {
        type: Array,
        default: () => {[]}
    },
    keyName: {
        default: ''
    },
    userList: {
      type: Array,
      default: () => {[]}
    },
    kpiListAll: {
      type: Array,
      default: () => {[]}
    },
    groupPermissionList: {
      type: Array,
      default: () => {[]}
    },
    newTempOrgName: {
      default: ''
    }
  },
  data() {
    return {
      filterForm: {
        name: '',
        kpiName: ''
      },
      listUserSelected: [],
      userListCopy: [],
      kpiListAllCopy: [],
      listKpiSelected: [],
      listPermissionSelected: [],
      tempRankName: '',
      tempOrgName: ''
    };
  },
  created() {
    this.userListCopy = [ ...this.userList ]
    this.kpiListAllCopy = [ ...this.kpiListAll ]
  },
  methods: {
    async updateBranch(child) {
      if(!child.name.trim()) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Tên nhánh không được để trống!'
        });
        child.name = this.newTempOrgName ? this.newTempOrgName : this.tempOrgName
        child.showEdit = false;
        return
      }

      let dataUpdateBranch = {
        name: child.name
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateBranch(child.id, dataUpdateBranch)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        child.showEdit = false
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
        child.name = this.newTempOrgName ? this.newTempOrgName : this.tempOrgName
        child.showEdit = false
      }
      loading.hide()
    },
    showContent() {

    },
    editTraining(item) {

    },
    deleteTraining(item) {
        Bus.$emit('delete-training-from-tree', item)
    },
    async addPermission() {

    },
    async addRank(item) {
      this.tempRankName = '';
      let childTemp = {
        name: 'Default ' + (item.ranks.length + 1),
        orgId: item.id,
        // level: item.level + 1,
        ministryId: item.ministryId
      }
      // return

      let res = await organizationMachineRepository.createRank(childTemp)
      if (res.success) {
        this.tempRankName = 'Default ' + (item.ranks.length + 1)
        let childReturn = _.get(res, 'data', childTemp)
        childReturn.name = '';
        childReturn.showEdit = true;
        childReturn.idTemp = moment().unix();

        let index = this.noteData.findIndex(e => e.id == item.id)
        if (index > -1) {
          this.noteData[index].ranks.push(childReturn)
        }

        this.$nextTick(() => {
          document.getElementById(`input_rank_name_${childReturn.id}`).focus();
          document.getElementById(`input_rank_name_${childReturn.id}`).click();
        })

      }
    },
    async updateRank(rank) {

      if(!rank.name.trim()) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Tên lộ trình làm việc không được để trống!'
        });
        rank.name = this.tempRankName ? this.tempRankName : `Default ${rank.id}`
        rank.showEdit = false;
        return
      }

      let dataUpdateBranch = {
        name: rank.name
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateRank(rank.id, dataUpdateBranch)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        rank.showEdit = false
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
        rank.name = this.tempRankName ? this.tempRankName : `Default ${rank.id}`
        rank.showEdit = false;
      }
      loading.hide()
    },
    editRank(child) {
      this.tempRankName = child.name
      child.showEdit = true;
      this.$nextTick(() => {
        document.getElementById(`input_rank_name_${child.id}` ).focus();
        document.getElementById(`input_rank_name_${child.id}`).click();
      });
    },
    async deleteRank(item, rank) {
      if(!rank.users || !rank.users.length) {
        this.$swal({
          title: `Bạn có thực sự muốn xóa rank ${rank.name}`,
          cancelButtonText: 'Bỏ qua',
          showCancelButton: true,
          confirmButtonText: 'Xác nhận'
        }).then( async (res) => {
          if (res.value) {
            const loading = this.$loading.show()
            let res = await organizationMachineRepository.deleteRank(rank.id)
            if (res.success) {
              this.$swal({
                text: 'Cập nhật dữ liệu thành công!',
                timer: 1000,
                showConfirmButton: false,
                icon: 'success'
              });
              let index = item.ranks.findIndex(e => e.id == rank.id);
              if(index > -1) {
                item.ranks.splice(index, 1)
              }
            } else {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: 'Lỗi !',
                text: _.get(res, 'message', '')
              });
            }
            loading.hide()
          }
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Bạn không thể xóa Rank đang có nhân sự!'
        });
      }
    },
    async addBranch(item) {
      if(item.level && item.level < 5) {
        item.isShow = true;
        this.tempOrgName = "";
        let childTemp = {
          name: 'Default ' + (item.children.length + 1),
          parentId: item.id,
          level: item.level + 1,
          ministryId: item.ministryId
        }

        let res = await organizationMachineRepository.createBranch(childTemp)
        if (res.success) {
          this.tempOrgName = 'Default ' + (item.children.length + 1);
          let childReturn = _.get(res, 'data', childTemp)
          childReturn.name = '';
          childReturn.showEdit = true;
          // childReturn.idTemp = moment().unix();

          let index = this.noteData.findIndex(e => e.id == item.id)
          if(index > -1) {
            this.noteData[index].children.push(childReturn)
          }

          this.$nextTick( () => {
              document.getElementById(`input_branch_name_${childReturn.id}` ).focus();
              document.getElementById(`input_branch_name_${childReturn.id}`).click();
          })
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(res, 'message', '')
          });
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Bạn không được tạo cấp lớn hơn 5!'
        });
      }
    },
    editBranch(child) {
      child.showEdit = true;
      this.tempOrgName = child.name;
      this.$nextTick(() => {
        document.getElementById(`input_branch_name_${child.id}` ).focus();
        document.getElementById(`input_branch_name_${child.id}`).click();
      })
    },
    async deleteBranch(item) {
      if(!item.children || !item.children.length) {
        this.$swal({
          title: `Bạn có thực sự muốn xóa nhánh ${item.name}`,
          cancelButtonText: 'Bỏ qua',
          showCancelButton: true,
          confirmButtonText: 'Xác nhận'
        }).then( async (res) => {
          if (res.value) {
            const loading = this.$loading.show()
            let res = await organizationMachineRepository.deleteBranch(item.id)
            if (res.success) {
              this.$swal({
                text: 'Cập nhật dữ liệu thành công!',
                timer: 1000,
                showConfirmButton: false,
                icon: 'success'
              });
              let index = this.noteData.findIndex(e => e.id == item.id);
              if(index > -1) {
                this.noteData.splice(index, 1)
              }
            } else {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: 'Lỗi !',
                text: _.get(res, 'message', '')
              });
            }
            loading.hide()
          }
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Bạn không thể xóa Nhánh đang có cấp dưới!'
        });
      }
    },
    searchUser() {
      if(this.filterForm.name.trim()) {
        this.userListCopy = this.userList.filter(element => element.fullName.toUpperCase().includes(this.filterForm.name.toUpperCase()))
      } else {
        this.userListCopy = [ ...this.userList ]
      }
    },
    async saveUserForRank(rank) {
      rank.openMenu = false
      const userIds = {
        userIds: this.listUserSelected && this.listUserSelected.length ? [ ...this.listUserSelected ] : []
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateUserForRank(rank.id, userIds)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });

        const oldUserArrInRank = rank.users.filter(elm => this.listUserSelected.includes(elm .id))

        const newUserArrInRank = this.userList.filter(element => this.listUserSelected.includes(element.id)).map((item) => {
          return {
            avatar: item.avatar ? item.avatar : '',
            fullName: item.fullName,
            id: item.id,
          }
        })
        rank.users = oldUserArrInRank.concat(newUserArrInRank)
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()
    },
    openFormSelectUser(rank) {
      this.listUserSelected = rank.users.map(elm => elm.id)
      Bus.$emit('get-list-user-ministry-available')
    },
    searchKpi() {

    },
    openFormSelectKpi(item) {
      this.listKpiSelected = item.indicators.map(elm => elm.id)
    },
    async saveKpiForBranch(item) {

      item.openMenu = false
      const indicatorIds = {
        indicatorIds: this.listKpiSelected && this.listKpiSelected.length ? [ ...this.listKpiSelected ] : []
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateKpiForBranch(item.id, indicatorIds)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        // item.indicators = []
        let indicators = []
        this.kpiListAll.forEach(element => {
          element.indicators.forEach(ite => {
            if(this.listKpiSelected.includes(ite.id)) {
              indicators.push(ite)
            }
          })
        })
        console.log('indicators: ', indicators)
        item.indicators = [ ...indicators ]
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()
    },
    handleSelectKpi(item) {
      if(this.listKpiSelected.includes(item.id)) {
        let index = this.listKpiSelected.findIndex(ele => ele === item.id)
        if(index > -1) {
          this.listKpiSelected.splice(index, 1);
        }
      } else {
        this.listKpiSelected.push(item.id)
      }
    },
    openMenuSelectPermission(item) {
      // this.listPermissionSelected = item.roles.map(elm => elm.id)
    },
    async saveRolesForBranch(item) {
      item.openMenuPermission = false
      const roleIds = {
        roleIds: this.listPermissionSelected && this.listPermissionSelected.length ? [ ...this.listPermissionSelected ] : []
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateRolesForBranch(item.id, roleIds)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        let roles = []
        this.groupPermissionList.forEach(element => {
          element.roles.forEach(ite => {
            if(this.listPermissionSelected.includes(ite.id)) {
              roles.push(ite)
            }
          })
        })
        item.roles = [ ...roles ]
        this.listPermissionSelected = []
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()
    },
    handleSelectRoles(item) {
      if(this.listPermissionSelected.includes(item.id)) {
        let index = this.listPermissionSelected.findIndex(ele => ele === item.id)
        if(index > -1) {
          this.listPermissionSelected.splice(index, 1);
        }
      } else {
        this.listPermissionSelected.push(item.id)
      }
    }
  }
}
</script>

<style scoped>
.tree-header-icon {
    min-width: 52px;
    padding: 0px 5px;
    text-align: right;
}

.icon-rotate {
    transform: rotate(90deg);
}

.content-tree-note {
    font-size: 16px;
    /*margin: 4px 0px;*/
}

.content-tree-note.active {
    /*background-color: #e6f2ff;*/
    cursor: pointer;
}

.content-tree-note .tree-action-btn {
    display: none;
}

.tree-header-name:hover, .rank-data-content {
  cursor: pointer;
}

.tree-header-name:hover .tree-action-btn, .content-tree-note.active .tree-action-btn {
    display: inherit;
}

.tree-header-name {
    max-width: 100%;
    width: fit-content;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
    overflow: hidden;
}

.content-tree-note:hover .btn-action-branch {
  /*display: inherit;*/
  cursor: pointer;
  visibility: unset;
}
.rank-item-actions, .btn-action-branch {
  /*display: none;*/
  visibility: hidden;
  font-size: 14px;
  color: #2D9CDB;
  padding: 6px 0px 0px 24px;
}
.rank-data-content:hover .rank-item-actions {
  /*display: inline;*/
  visibility: unset;
}
.v-menu__content.wrapper-v-menu {
  background: white !important;
}

.v-menu__content .style-1::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 20px;
  background-color: #F5F5F5;
}

.v-menu__content .style-1::-webkit-scrollbar
{
  width: 3px;
  background-color: #9B51E0;
}

.v-menu__content .style-1::-webkit-scrollbar-thumb
{
  border-radius: 20px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #9B51E0;
}
.item-user-list-wrapper {
  padding: 0 16px;
}
.wrapper-list-item {
  max-height: 150px;
  overflow-y: auto;
}
.item-user-content {
  padding: 5px 10px;
  border-bottom: 1px solid #f3efef;
}
.btn-confirm {
  border: 1px solid darkgrey;
  border-radius: 5px;
  font-weight: bold;
  text-transform: uppercase;
  color: black;
  cursor: pointer;
}
.selected {
  background: #1E90FF;
}
.item-avatar-user {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  transform: translate(0, 2px);
}
.more-item-user {
  font-size: 9px;
  background: gainsboro;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
.item-kpi-wrapper {
  padding: 0 16px;
}
.item-kpi-content {
  padding: 5px 10px;
  background-color: #EFEEFF;
  color: #7367F0;
  border-radius: 5px;
  display: inline-block;
  margin-bottom: 5px;
}
.btn-confirm {
  border: 1px solid darkgrey;
  border-radius: 5px;
  font-weight: bold;
  text-transform: uppercase;
  color: black;
  cursor: pointer;
}
.item-kpi-content-unselect {
  padding: 5px 10px;
  background-color: #F2F2F2;
  color: black;
  border-radius: 5px;
  cursor: pointer;
  display: inline-block;
}
.border-bottom {
  border-bottom: 1px solid #F2F2F2;
}
.v-menu__content {
  background: white !important;
}
.btn-action-item:hover {
  background-color: #dfe8ec;
  border-radius: 5px;
}
.btn-action-item {
  width: 33%;
  cursor: pointer;
  text-align: center;
}
.item-role-content {
  padding: 5px 10px;
  background-color: #EFEEFF;
  color: #7367F0;
  border-radius: 5px;
  cursor: pointer;
}
.item-role-content-unselect {
  padding: 5px 10px;
  background-color: #F2F2F2;
  color: black;
  border-radius: 5px;
  cursor: pointer;
}
/deep/ .mdi-plus::before {
  font-weight: bold;
}
.btn-edit-kpi {
  text-decoration: underline;
  margin-right: 10px;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
}
.icon-header-tree-note {
  margin-right: 2px;
  position: absolute;
  top: 6px;
  right: 0px;
  cursor: pointer;
}
.li-line {
  position: relative;
}
.li-line::before {
  content: "";
  position: absolute;
  background: none;
  height: 100%;
  width: 2px;
  left: 60px;
  top: 41px;
  border-left: 1px dashed gray;
}
.li-line-2::before {
  content: "";
  position: absolute;
  background: none;
  height: 96%;
  width: 2px;
  left: 80px;
  top: 41px;
  border-left: 1px dashed gray;
}
.li-line-3::before {
  content: "";
  position: absolute;
  background: none;
  height: 96%;
  width: 2px;
  left: 80px;
  top: 41px;
  border-left: 1px dashed gray;
}
.li-line-4::before {
  content: "";
  position: absolute;
  background: none;
  height: 96%;
  width: 2px;
  left: 100px;
  top: 41px;
  border-left: 1px dashed gray;
}
.li-line-5::before {
  content: "";
  position: absolute;
  background: none;
  height: 96%;
  width: 2px;
  left: 100px;
  top: 41px;
  border-left: 1px dashed gray;
}
input:focus {
  outline: none;
  border-radius: 5px;
}
</style>